import PageHeader from "../../../components/PagesComponents/UniversalComponents/PageHeader.component";
import PathChanger from "../../../components/PagesComponents/Setting/Profile/PathChanger.component";
// import { ReactComponent as AdminInfoIcon } from "../../../assets/Icons/Setting/Profile/AdminInfoIcon.svg";
import { ReactComponent as StudentAppIcon } from "../../../assets/Icons/Setting/Accissibility/StudentAppIcon.svg";
import { ReactComponent as StaffAppIcon } from "../../../assets/Icons/Setting/Accissibility/StaffAppIcon.svg";
import { Helmet } from "react-helmet";

const Body = ({
  currentTab,
  handelCurrentTab,
}) => {
  return (
    <div
      className="flex-col align-start justify-start g-1 overflow-hide   "
      style={{ height: "calc(90vh - 1rem)" }}
    >
      <Helmet>
        <title>Accissibility</title>
      </Helmet>
      <PageHeader />

      <div className="w-full overflow-hide flex-row align-start justify-start g-1 flex-1 ">
        {/* left container */}
        <div
          className=" flex-col align-start justify-between g-1 h-full"
          style={{ width: "18rem" }}
        >
          <div
            className="h-full  w-full flex-col align-start justify-start p-2 back-white radius-10"
            style={{ gap: "1.2rem", padding: "1.2rem" }}
          >
            <h4 className="t-15 poppins-medium weight-500">
              Horizontal access
            </h4>
            <div className="w-full flex-col-align-start-justify-start g-05">
              <PathChanger
                title={"Student app"}
                icon={
                  <StudentAppIcon
                    className={
                      currentTab === "studentApp"
                        ? "activeSettingPathChangerBtnIcon"
                        : ""
                    }
                  />
                }
                pathName={"studentApp"}
              />

              <PathChanger
                title={"Staff app"}
                icon={
                  <StaffAppIcon
                    className={
                      currentTab === "staffApp"
                        ? "activeSettingPathChangerBtnIcon"
                        : ""
                    }
                  />
                }
                pathName={"staffApp"}
              />
            </div>
          </div>
        </div>

        {/* right container */}
        <div className="flex-col align-start justify-start flex-1  scroll-y pr-1 h-full">
          {handelCurrentTab()}
        </div>
      </div>
    </div>
  );
};

export default Body;
